// extracted by mini-css-extract-plugin
export default {"toast-message":"toast-message","toastMessage":"toast-message","disappear":"disappear","error":"error","success":"success","warning":"warning","icon":"icon"};